import { createContext, useContext } from "react";

// POC: exposes useMenuDataPrefetch's refetch control to consumers below DigitalMenuConfigLoader,
// e.g. the age-consent gate triggering a refetch with consent=false on decline.
export interface IMenuPrefetchContext {
    refetchWithConsent: (consent: boolean) => Promise<void>;
}

const noop = async () => {};

export const MenuPrefetchContext = createContext<IMenuPrefetchContext>({
    refetchWithConsent: noop,
});

export const useMenuPrefetch = () => useContext(MenuPrefetchContext);
